import { providers } from "@/utils/constants";

export default {
  SET_PROVIDERS({ commit }) {
    commit("SET_PROVIDERS", providers);
  },
};
